import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import {
  PropertiesActionType, GetPropertyInfo, SetPropertyInfo, SetSelectedProperty, GetAirSpaceDbLink,
  SetPropertiesDbLinks, GetPropertyByXY, SetPropertyBoundingBox, GetPropertyBoundingBox, PrintSvcConn,
  GetPrintSvcConn, SetPrintSvcConn, SetAddressByDbLink, ResetGeoJsonProperty, GetEnerGovInfo, SetEnerGovInfo
} from './properties.action';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { switchMap, mergeMap, delay } from 'rxjs/operators';
import { SearchService, ConfigService, PropertiesService } from 'src/app/services';
import { GetShape, ToastUserNotification, RefreshDisplayedGeoJson, DelayedAction, DelayedActionBy1, SetShowSearchSpinner } from '../application/application.action';
// import { SetMapGeoJsonLayers } from 'dnv-lib';


@Injectable()
export class PropertiesEffects implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getPropertyByXY$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.GetPropertyByXY),
    switchMap((action: any) => this.propertiesService.getPropertyByXY(action.payload)
      .pipe(
        mergeMap((data: any) => {
          if (data.features.length > 1) {
            let dbLink = '';
            for (const [i, feature] of data.features.entries()) {
              if (i === data.features.length - 1) {
                dbLink += feature.attributes.DBLink;
              } else {
                dbLink += feature.attributes.DBLink + ',';
              }
            }

            return [
              new GetAirSpaceDbLink(dbLink)
            ];
          } else if (data.features.length === 1) {
            return [
              new GetShape(data.features[0].attributes.DBLink),
              new GetPropertyInfo(data.features[0].attributes.DBLink),
              new SetSelectedProperty('')
            ];
          } else {
            return [
              new ToastUserNotification({
                type: 'fail',
                title: 'Parcel not located',
                message: 'Your map click did not locate a parcel. Please try again or use the address search.',
                options: {
                  disableTimeOut: true,
                  closeButton: true
                }
              })
            ];

          }
        }
        )
      )
    )
  ));

  GetAirSpaceDbLink$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.GetAirSpaceDbLink),
    switchMap((action: any) => this.searchService.getAirSpaceDbLink(action.payload)
      .pipe(
        mergeMap((result: any) => {
          // console.log('air space ', result);
          return [
            new SetPropertiesDbLinks(result),
            new SetPropertyInfo([]),
            new ResetGeoJsonProperty()
            // new SetMapGeoJsonLayers([])
          ];
        }
        )
      )
    )
  ));

  // tslint:disable-next-line: member-ordering
  GetPropertyInfo$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.GetPropertyInfo),
    switchMap((action: any) => this.propertiesService.getPropertyInfo(action.payload)
      .pipe(
        mergeMap((data: any) => {
          //  console.log('property info: ', data);
          const actions: Action[] = [];
          actions.push(new SetPropertyInfo(data));
          actions.push(new SetShowSearchSpinner(false));
          if (data[0].properties[0].addresses.length <= 1) {
            actions.push(new GetEnerGovInfo(data[0].properties[0].dbLink));
          }
          return actions;
        }
        )
      )
    )
  ));

  // tslint:disable-next-line: member-ordering
  GetPropertyByAddress$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.GetPropertyByAddress),
    switchMap((action: any) => this.propertiesService.getProperty(action.payload.address, action.payload.dblink, action.payload.ltopid)
      .pipe(
        mergeMap((data: any) => {
          //  console.log('property info: ', data);
          const actions: Action[] = [];
          actions.push(new SetShowSearchSpinner(false));
          if (!data[0].properties[0]) {
            actions.push(
              new ToastUserNotification({
                type: 'error',
                title: 'Error',
                message: 'There is a problem with this address: ' + action.payload.address,
                options: {
                  disableTimeOut: true,
                  closeButton: true
                }
              })
            );
            return actions;
          } else {
            actions.push(new SetPropertyInfo(data));
            if (data[0].properties[0].addresses.length <= 1) {
              actions.push(new GetEnerGovInfo(data[0].properties[0].dbLink));
            }
            if (action.payload.search) {
              actions.push(new GetShape(data[0].properties[0].dbLink));
            }
            return actions;
          }
        }
        )
      )
    )
  ));

  // tslint:disable-next-line: member-ordering
  GetPropertyByFolio$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.GetPropertyByFolio),
    switchMap((action: any) => this.propertiesService.getPropertyByFolio(action.payload)
      .pipe(
        mergeMap((data: any) => {
          //  console.log('property info: ', data);
          return [
            new SetPropertyInfo(data),
            new GetEnerGovInfo(data[0].properties[0].dbLink),
            new SetShowSearchSpinner(false)
          ];
        }
        )
      )
    )
  ));

  // tslint:disable-next-line: member-ordering
  GetPropertyByPID$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.GetPropertyByPID),
    switchMap((action: any) => this.propertiesService.getPropertyByPID(action.payload)
      .pipe(
        mergeMap((data: any) => {
          //  console.log('property info: ', data);
          const actions: Action[] = [];
          actions.push(new SetShowSearchSpinner(false));
          actions.push(new SetPropertyInfo(data));
          if (data[0].properties[0].addresses.length <= 1) {
            actions.push(new GetEnerGovInfo(data[0].properties[0].dbLink));
          }
          return actions;
        }
        )
      )
    )
  ));

  GetPropertyBoundingBox$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.GetPropertyBoundingBox),
    switchMap((action: any) => this.propertiesService.getPropertyBoundingBoxDbLink(action.payload)
      .pipe(
        mergeMap((data: any) => {
          //  console.log('property info: ', data);
          return [
            new SetPropertyBoundingBox(data)
          ];
        }
        )
      )
    )
 ));

  // tslint:disable-next-line: member-ordering
  GetEnergovInfo$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.GetEnerGovInfo),
    switchMap((action: any) => this.propertiesService.getEnerGovInfo(action.payload)
      .pipe(
        mergeMap((data: any) => {
          // console.log('energov info: ', data);

          return [
            new SetEnerGovInfo(data)
          ];
        }
        )
      )
    )
  ));

 
  resetGeoJsonProperty$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.ResetGeoJsonProperty),
    delay(0),
    mergeMap((action: ResetGeoJsonProperty) => {
      return [new RefreshDisplayedGeoJson()];
    })
  ));

 
  PrintSvcConn$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.PrintSvcConn),
    delay(0),
    mergeMap((action: PrintSvcConn): any => {
      window.open('/serviceconnections?dblink=' + action.payload.dblink + '&opacity=' + action.payload.opacity + '&token=' + action.payload.token, '_blank');
      return [];
    })
  ));

  GetPrintSvcConn$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.GetPrintSvcConn),
    switchMap((action: any) => this.searchService.getServiceConnectionsByDbLink(action.payload)
      .pipe(
        mergeMap((data: any) => {
          // console.log('svc conn: ', data);
          return [
            new SetPrintSvcConn(data)
          ];
        }
        )
      )
    )
  ));

  GetAddressByDbLink$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.GetAddressByDbLink),
    switchMap((action: any) => this.searchService.getAddressDbLink(action.payload)
      .pipe(
        mergeMap((data: any) => {
          // console.log('svc conn: ', data);
          return [
            new SetAddressByDbLink(data)
          ];
        }
        )
      )
    )
 ));

  getServiceConnectionsByLatLong$ = createEffect((): any => this.actions$.pipe(
    ofType(PropertiesActionType.GetServiceConnectionsByLatLong),
    switchMap((action: any) => this.searchService.getServiceConnectionsByLatLong(action.payload.lat, action.payload.lng)
      .pipe(
        mergeMap((data: any) => {
          if (data !== null) {
            return [
              new GetShape(data.dblink),
              new SetPrintSvcConn(data)
            ];
          }
          else {
            return [
              new ToastUserNotification({
                type: 'fail',
                title: 'Service Connection Details Not Found',
                message: 'Your map click did not locate a parcel. Please try again or use the address search.',
                options: {
                  disableTimeOut: true,
                  closeButton: true
                }
              })
            ];

          }
        }
        )
      )
    )
  ));

  constructor(
    private actions$: Actions,
    // tslint:disable-next-line: ngrx-no-typed-store
    // private store$: Store<State>,
    private searchService: SearchService,
    private toastr: ToastrService,
    private configService: ConfigService,
    private propertiesService: PropertiesService
  ) { }

}
